const textOverflowStyle = {
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
};

const scrollbarStyle = {
  overflowX: 'hidden',
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    width: 4,
    backgroundColor: 'transparent',
  },

  '&::-webkit-scrollbar-thumb': {
    width: 4,
    height: 44,
    backgroundColor: '#EBEAE8',
  },
};

export const getStyles = (_, { palette = { }, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  goalSelectorContainer: {
    width: 465,
    paddingBottom: 30,
    '& .focusStyle': {
      border: '1px solid black',
    },
    '& .ba-search-box ': {
      borderTop: '1px solid #ccc',
      borderLeft: '1px solid #ccc',
      borderRight: '1px solid #ccc',
      padding: 1,
      position: 'relative',

      // #323130
      '& .search-box__input': {
        height: 48,
        width: 'calc(100% - 2px)',
        border: 0,
        borderBottom: '1px solid #ccc',
        paddingLeft: 48,
        marginLeft: 1,
      },

      '& .search-box__icon': {
        fontFamily: iconFontFamily,
        fontSize: 16,
        verticalAlign: 'middle',
        position: 'absolute',
        left: 17,
        top: 13,
      },

      '& .search-box__icon:before': {
        content: '"\\E721"',
        color: palette.themePrimary,
      },
    },

    '& .list-selector-container': {
      width: 470,
      height: 329,
    },

    '& .ba-list-selector': {
      display: 'flex',
      'flex-direction': 'column',

      '& .list-selector-action-bar': {
        '& [class*="-all-content"]': {
          padding: '10px 12px',
          color: '#0078D4',
          cursor: 'pointer',
          '& span': {
            '&:hover': {
              color: '#004578',
              textDecorationLine: 'underline',
            },
          },
        },
        '& .select-all-content .enabled.arrow-button': {
          float: 'right',
        },
        '& .remove-all-content .remove.arrow-button': {
          float: 'right',
        },
      },

      '& .list-selector-header': {
        '& .panel-heading': {
          color: palette.neutralPrimary,
          fontSize: 14,
          padding: '7px 8px',

          '& .panel-title': {
            fontSize: 14,
            marginTop: 0,
          },
        },
      },

      '& .list-selector-content': {
        height: 270,
        ...scrollbarStyle,
        '& .list-selector-item': {
          margin: 0,
          minHeight: 36,

          '& .added-to-result-list': {
            background: '#edebe9',
          },
          '& .item-content': {
            ...textOverflowStyle,
            cursor: 'pointer',
            '& .text': {
              verticalAlign: 'middle',
            },
          },
        },

        '& .selected': {
          background: '#edebe9',
        },
      },

      '& .list-selector-item:hover': {
        background: '#edebe9',
      },

      '& .list-selector-item:focus': {
        outline: 'none',
        border: '1px solid  ',
      },
    },

    '& .list-selector-empty': {
      marginLeft: 10,
    },

  },

  goalSelector: {
    position: 'relative',
    marginBottom: 15,

    '& .ba-goal-selector .multi-selector-content':
    {
      height: 400,

      '&> .ba-entity-selector': {
        borderRight: '1px solid #ccc',
        minWidth: 'fit-content',
        height: 400,
      },
    },

    '& .ba-goal-selector': {
      width: 'fit-content',
      display: 'flex',
      '& .ba-list-selector': {
        width: 470,
      },
    },

    '& .multi-selector-result-container': {
      margin: '0 0 0 20px',
      borderLeft: '1px solid #ccc',
      height: 400,
      '& .list-selector-container': {
        height: 380,
      },
      '& .list-selector-content': {
        height: 320,
        ...scrollbarStyle,
        '& .list-selector-item': {
          margin: 0,
          minHeight: 36,

          '& .added-to-result-list': {
            background: '#edebe9',
          },
          '& .item-content': {
            ...textOverflowStyle,
            cursor: 'pointer',
            '& .text': {
              verticalAlign: 'middle',
            },
          },
        },

        '& .selected': {
          background: '#edebe9',
        },
      },
      '& .list-selector-container ': {
        height: 400,
        '.ba-list-selector': {
          display: 'flex',
          width: 470,
        },
      },
      '& .pagination-container': {
        paddingTop: 5,
        '& .ba-pagination': {
          height: 35,
          padding: 0,
        },
      },
    },


    '& .pagination-container': {
      paddingTop: 25,
      '& .ba-pagination': {
        height: 35,
        padding: 0,
      },
    },

    rowItem: {
      padding: '7px 8px 8px 8px',
      display: 'flex',
      alignItems: 'center',
      maxWidth: 'unset !important',
    },
    goalNameColumn: {
      width: 300,
      marginRight: 10,
      ...textOverflowStyle,
    },
    goalTypeColumn: {
      width: 180,
      marginRight: 10,
      ...textOverflowStyle,
    },
    trackingStatusIcon: {
      width: 20,
    },
    hideIcon: {
      display: 'none',
    },
    arrowIcon: {
      width: 15,
      marginLeft: '0 !important',
      marginRight: '0 !important',
    },
    selectionCount: {
      position: 'absolute',
      top: 36,
      left: 9,
      background: '#fff',
      pointerEvents: 'none',
    },
  },

  rowItem: {
    padding: '7px 8px 8px 8px',
    display: 'flex',
    alignItems: 'center',
    maxWidth: 'unset !important',
  },
  goalNameColumn: {
    width: 300,
    marginRight: 10,
    ...textOverflowStyle,
  },
  goalTypeColumn: {
    width: 180,
    marginRight: 10,
    ...textOverflowStyle,
  },
  trackingStatusIcon: {
    width: 20,
  },
  hideIcon: {
    display: 'none',
  },
  arrowIcon: {
    width: 15,
    marginLeft: '0 !important',
    marginRight: '0 !important',
  },
  selectionCount: {
    position: 'absolute',
    top: 36,
    left: 9,
    background: '#fff',
    pointerEvents: 'none',
  },
  manuallyAddBrand: {
    paddingLeft: 9,
    marginTop: 10,
    fontWeight: 600,
  },
});
